import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
  Chip,
} from "@material-ui/core";

import {
  Check,
  ExpandMore,
  Add,
  EditOutlined,
  DeleteOutlined,
} from "@material-ui/icons";

import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import { TableContent, HeaderAccordion } from "../styles/Vendedor";
import TableDefault from "../../../../components/grid/TableDefault";
import { VendedoresContext } from "../contexts/VendedoresContext";
import useVendedorController from "../controllers/VendedorController";
import ModalVendedorInfosBancarias from "./ModalVendedorInfosBancarias";
import { IconButtonStyled } from "../styles/Vendedor";

export default function AccordionVendedorInfosBancarias() {
  const { expanded, bank, geralErrors, open, setOpen, listBank } =
    useContext(VendedoresContext);

  const { handleChangeOpenAccordion, handleDeleteSellerBankAccount } =
    useVendedorController();

  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        return (
          <SpeedDialErp
            actions={[
              {
                icon: <EditOutlined />,
                name: "Editar",
                action: () => {
                  setRowEdit(item);
                  setOpen(true);
                },
              },
              {
                icon: <DeleteOutlined />,
                name: "Excluir",
                action: () => handleDeleteSellerBankAccount(item),
              },
            ]}
          />
        );
      },
    },
    {
      id: "conta_padrao_flag",
      label: "Principal",
    },
    {
      format: (item) => {
        const bank = listBank.find((opt) => opt.codigo === item.codigo_banco);
        return bank?.nome;
      },
      label: "Banco",
    },
    {
      id: "agencia",
      label: "Agência",
    },
    {
      id: "conta",
      label: "Conta",
    },
    {
      id: "chave_pix",
      label: "Chavel PIX",
    },
    {
      id: "tipo_pix",
      label: "Tipo",
    },
  ];

  useEffect(() => {
    (async () => {
      const newList = [];
      bank.forEach(
        (item, index) =>
          (newList[index] = {
            ...item,
            conta_padrao_flag: item.conta_padrao ? (
              <div>
                <Tooltip title="Editar">
                  <Check />
                </Tooltip>
              </div>
            ) : (
              <></>
            ),
          })
      );
      setDataTable(newList);
    })();
  }, [bank]);

  return (
    <>
      <ModalVendedorInfosBancarias
        open={open}
        setOpen={setOpen}
        setRowEdit={setRowEdit}
        rowEdit={rowEdit}
      />

      <Grid item>
        <Accordion
          expanded={expanded.bank || false}
          onChange={() => handleChangeOpenAccordion("bank")}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={2}>
                <Grid item xs alignItems="center">
                  <Chip
                    bgcolor={
                      !expanded.general &&
                      geralErrors.accordions &&
                      geralErrors.accordions.includes("bank")
                        ? "red"
                        : "primary"
                    }
                    textcolor="white"
                    label="INFORMAÇÕES BANCÁRIAS"
                  />
                </Grid>
                <Grid item flex={1}>
                  <Tooltip title="Adicionar dados bancários">
                    <IconButtonStyled
                      onClick={() => {
                        setOpen(true);
                        setRowEdit(false);
                      }}
                    >
                      <Add />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        columns={columns}
                        values={dataTable}
                        tableTitle=""
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
